import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { sendCartResume, setStatus } from '@/routes/order';
import { OrderStatus } from '@/services/global';
import { ApplicationState } from '@/store';
import { IShopConfig } from '@/store/ducks/shopConfig/types';

import { useShipmentCardContext } from '../../../../hooks/useShipmentCardContext';

interface Props {
  title: string;
  isRedirectPaymentMethod?: boolean;
  showModal?: (show: boolean) => void;
  onClick?: () => void;
  backgroundColor?: string;
  isDisabled?: boolean;
  hasBlockedMedicine?: boolean;
  handleFinishOrder?: () => boolean;
  forwardedOrderAlert?: (alert: boolean) => void;
}

function FooterDefaultButton({
  title,
  showModal = () => {},
  onClick,
  isDisabled,
  hasBlockedMedicine,
  handleFinishOrder,
  backgroundColor,
  forwardedOrderAlert,
}: Props) {
  const selectShop = useSelector<ApplicationState, IShopConfig>((state) => state.shopConfig.data);
  const { disabled } = useShipmentCardContext();
  const { order } = useWebContext();

  return (
    <button
      disabled={disabled || isDisabled}
      style={backgroundColor ? { backgroundColor, color: useTextColor(backgroundColor) } : {}}
      onClick={() => {
        if (hasBlockedMedicine && handleFinishOrder?.() && order) {
          setStatus(order.id, OrderStatus.WAITING_SELLER)
            .then(async () => {
              forwardedOrderAlert?.(true);
              await sendCartResume(order.id, 'Resumo do Pedido');
              if (hasBlockedMedicine) {
                const messageText = `Quero enviar a receita médica do meu pedido ${order?.id}`;
                const encodedMessage = encodeURIComponent(messageText);
                window.open(
                  `https://api.whatsapp.com/send?phone=${selectShop.whatsapp}&text=${encodedMessage}`,
                );
              }
            })
            .catch((e) => {
              toast(e?.response?.data?.message ?? 'Erro ao enviar pedido', {
                type: 'warning',
                position: 'top-center',
              });
            });
          return;
        }
        if (hasBlockedMedicine && !handleFinishOrder?.()) return;
        if (onClick) {
          onClick();
          return;
        }
        showModal(true);
      }}
      className={`btn btn-block btn-${
        hasBlockedMedicine ? 'outline-secondary' : 'success'
      } mt-2 font-weight-bold`}
    >
      {!hasBlockedMedicine ? title : 'Envie a receita para concluir o pedido'}
    </button>
  );
}

export default FooterDefaultButton;
